"use client";

import NotFound from "@/components/shared/not-found";
import { usePageTitle } from "@/hooks/use-page-title";

export default function NotFoundPage() {
    // Set page title
    usePageTitle("NOT_FOUND");

    return <NotFound />;
}
